module.exports = __webpack_public_path__ + "img/change-menu.35d031ce.svg";